/**
 * @generated SignedSource<<cd7f4d7723c498d4834c2cbb2a0e5e0c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_viewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "topBar_issueNavigator_viewResult";
};
export type topBar_issueNavigator_viewResult$key = {
  readonly " $data"?: topBar_issueNavigator_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SaveResetViewSettingsButton"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "7af0493ac4b4294d3878240cc92132c9";

export default node;
